import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { DEFAULT_PAGE_SIZE_OPTIONS } from '@/hooks/use-pagination'
import { useTranslation } from '@/hooks/use-translation'

interface PaginationPageSizeProps {
  pageSize: number
  onPageSizeChange: (size: number) => void
  pageSizeOptions?: number[]
}

/**
 * Component for selecting the number of items per page.
 */
export function PaginationPageSize({
  pageSize,
  onPageSizeChange,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
}: PaginationPageSizeProps) {
  const t = useTranslation()

  return (
    <div className="flex items-center space-x-3">
      <p className="text-xs font-medium">{t('dataTable.rowsPerPage')}</p>
      <Select
        value={`${pageSize}`}
        onValueChange={(value) => {
          onPageSizeChange(Number(value))
        }}
      >
        <SelectTrigger className="w-[80px] text-xs h-6" size="sm">
          <SelectValue placeholder={pageSize} />
        </SelectTrigger>
        <SelectContent side="top">
          {pageSizeOptions.map((size) => (
            <SelectItem key={size} value={`${size}`} className="text-xs">
              {size}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
